import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminBreadcrumb from '../components/AdminBreadcrumb';
import { RouteNames, adminUserPath } from '../components/AppRouter';
import { apiService } from '../services/axios';
import { useAuth } from '../provider/AuthProvider';

function formatDate(iso) {
    const date = new Date(iso);

    return Number.isNaN(date.getTime()) ? iso : date.toLocaleDateString('fr-FR');
}

function AdminUsersPage() {
    const { token, isReady } = useAuth();
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [erreur, setErreur] = useState(null);

    useEffect(() => {
        if (!isReady || !token) {
            return undefined;
        }

        let annule = false;
        setIsLoading(true);

        apiService.get('/api/admin/users', isReady, token)
            .then((response) => { if (!annule) setUsers(response.data); })
            .catch(() => { if (!annule) setErreur('Impossible de récupérer les utilisateurs.'); })
            .finally(() => { if (!annule) setIsLoading(false); });

        return () => { annule = true; };
    }, [isReady, token]);

    return (
        <div className="hero-body is-align-items-flex-start">
            <div className="container">
                <AdminBreadcrumb trail={[{ libelle: 'Utilisateurs' }]} />

                <h1 className="title is-2">Utilisateurs</h1>

                {isLoading && <p className="has-text-grey">Chargement…</p>}
                {erreur && <div className="notification is-danger is-light">{erreur}</div>}

                {!isLoading && !erreur && users.length === 0 && (
                    <div className="notification is-info is-light">Aucun utilisateur.</div>
                )}

                {users.length > 0 && (
                    <table className="table is-fullwidth is-hoverable">
                        <thead>
                            <tr>
                                <th>Prénom</th>
                                <th>Email</th>
                                <th>Statut</th>
                                <th>Super admin</th>
                                <th>Inscrit le</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {users.map((user) => (
                                <tr key={user.id}>
                                    <td>{user.firstName}</td>
                                    <td>{user.email}</td>
                                    <td>
                                        <span className={`tag ${user.active ? 'is-success' : 'is-danger'}`}>
                                            {user.active ? 'Actif' : 'Inactif'}
                                        </span>
                                    </td>
                                    <td>{user.superAdmin ? <span className="tag is-dark">Oui</span> : '—'}</td>
                                    <td>{formatDate(user.createdAt)}</td>
                                    <td className="has-text-right">
                                        <Link className="button is-small" to={adminUserPath(user.id)}>
                                            Détail
                                        </Link>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}

                <Link to={RouteNames.admin} className="button is-light mt-4">Retour à l'administration</Link>
            </div>
        </div>
    );
}

export default AdminUsersPage;
